import calcUsingCanvas from './canvas-heatmap';
import caclUsingOldHeatmap from './heatmap';
import calcUsingRectSweepingLine from './rect-sweeping-line';
async function calculateTTVCPercentiles(arg) {
  const algo = 'canvas_heatmap';
  if (algo === 'canvas_heatmap') {
    const vcDetails = await calcUsingCanvas(arg);
    return vcDetails;
  }
  if (algo === 'rect_sweeping') {
    const vcDetails = await calcUsingRectSweepingLine(arg);
    return vcDetails;
  }
  if (algo === 'old_heatmap') {
    const vcDetails = await caclUsingOldHeatmap(arg);
    return vcDetails;
  }
  throw new Error('unexpected Error algo not chosen correctly');
}
export default calculateTTVCPercentiles;